import client from "api/config";
import { convertNum } from "helper/convert-num";

//////////////// gallary ////////////////
const slideUrl = "/admin/slides";
const getslideUrl = "/slides";

export const getSlidesImageRequest = () => client.get(getslideUrl);

export const deleteSlidesImageRequest = (id) =>
  client.delete(`${slideUrl}/${id}`);

export const getSlideImageByIdRequest = (values) =>
  client.get(`${getslideUrl}/${values.id}`);

export const addSlidesImageRequest = (values, onUploadProgress) => {
  let formData = new FormData();
  formData.append("alt", values.alt);
  formData.append("keyword", values.keyword);
  formData.append("title", values.title);
  formData.append("link", values.link);
  formData.append("text", values.text);
  formData.append("image", values.image.url);

  return client.post(slideUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

export const editSlideImageRequest = (values, onUploadProgress) => {
  const formData = new FormData();
  formData.append("title", values.title);
  formData.append("text", values.text);
  formData.append("alt", values.alt);
  formData.append("link", values.link);
  formData.append("keyword", values.keyword);

  !values.image.isWeb && formData.append("image", values.image.url);

  return client.post(`${slideUrl}/${values.id}?_method=put`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};
